import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    ...shorthands.overflow("auto"),
    ...shorthands.padding("16px", "0px", "16px", "0px"),
    ...shorthands.gap("6px"),
  },
  subcontainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "auto",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("auto"),
      maxWidth: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "auto",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("auto"),
      maxWidth: "1040px",
    },
  },
});
